import { CurrencySymbols } from '@infra/utils';
import { useMemo } from 'react';

export const TransactionsTableAmountCell = ({ cell: { value: amount } }) => {
  const currency = useMemo(() => {
    switch (amount.currency) {
      case 'try':
        return CurrencySymbols.TRY;
      case 'usd':
        return CurrencySymbols.USD;
      case 'azn':
        return CurrencySymbols.AZN;
      default:
        return amount.currency;
    }
  }, [amount.currency]);

  return `${amount.value.toFixed(2)} ${currency}`;
};
